import Grid from '@mui/material/Grid2';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { SubmissionsTotals } from './components/SubmissionsTotals';
import { SubmissionsTabs } from './components/SubmissionsTabs';
import { SubmissionBlock } from './components/SubmissionBlock';
import { useAppSelector } from '../../../hooks/useAppStore';
import {
  getSubmissionsTab,
} from '../../../store/tasklists/selectors';
import { DailySubmissionBlock } from './components/DailySubmissionBlock';
import { ToSubmitBlock } from './components/ToSubmitBlock';
import { MobileSubmissionsNav } from './components/MobileSubmissionsNav';

const SubmissionTab = () => {
  const submissionTab = useAppSelector(getSubmissionsTab);
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <Grid container spacing={3}>
      <Grid size={{
        xs: 12, lg: 8, md: 8,
      }}
      >
        <SubmissionsTotals />
        {submissionTab === '2' && <DailySubmissionBlock /> }
        {submissionTab === '3' && <ToSubmitBlock />}
        {submissionTab === '1' && <SubmissionBlock /> }
      </Grid>
      {!isMobile && (
      <Grid size={{
        lg: 4, md: 4,
      }}
      >
        <SubmissionsTabs />
      </Grid>
      )}
      <MobileSubmissionsNav />
    </Grid>
  );
};

export {
  SubmissionTab,
};
